<template lang="pug">
v-fade-transition(mode='out-in')
  #home
    section-news-carousel(:articles='articles')
    section-home-hero(:articles='articles')
    section-home-overview
    section-info-alt
</template>

<script setup>
import { useRoute, useRuntimeConfig } from 'nuxt/app'
import {
  createAbsoluteUrl,
  createPageSchemaContext,
  createSeoMeta,
} from '~/utils/schema'

defineOptions({
  name: 'Home',
})

const route = useRoute()
const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()
const { baseUrl, pageUrl } = createPageSchemaContext(
  route.path,
  runtimeConfig.public.baseUrl,
)
const description = t('seo.homeDescription')
const imageUrl = createAbsoluteUrl('/media/brand/EoT-blue-full.png', baseUrl)

useSeoMeta(
  createSeoMeta('Enterprise of Things Lab', description, pageUrl, imageUrl),
)

const { data: articles } = await useAsyncData('allArticles', () =>
  queryCollection('articles').order('date', 'DESC').limit(5).all(),
)
</script>

<style lang="sass">
.extra-padding
  padding-bottom: 96px !important
  padding-top: 96px !important

  @media screen and (max-width: 959px)
    padding-top: 48px !important
    padding-bottom: 48px !important
</style>
